import { ExportSquare } from 'iconsax-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

import { Chip } from '../../../components/Chip/Chip'

interface ImpersonationProfileItemProps {
  userName: string
  platform: string
  url: string
  image?: string
  isSuspected?: boolean
}

export const ImpersonationProfileItem = ({
  userName,
  platform,
  url,
  image,
  isSuspected = false,
}: ImpersonationProfileItemProps) => {
  const { t } = useTranslation()

  const initials = (userName || '?').replace('@', '').slice(0, 2).toUpperCase()

  return (
    <div className="bg-baseColor rounded-2xl flex flex-row items-center justify-between p-3 h-[65px] w-full max-sm:p-1.5">
      <div className="flex items-center gap-3 min-w-0">
        <Avatar>
          <AvatarImage src={image} />
          <AvatarFallback className="bg-baseColorHighlight text-neutralColor">
            {initials}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col min-w-0">
          <p className="text-neutralColor text-base font-medium truncate">
            {userName || t('impersonation.report.unknownUser')}
          </p>
          <p className="text-neutralColor60 text-sm font-medium truncate">
            {url}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        <Chip
          variant={isSuspected ? 'red' : 'green'}
          size="tag"
          text={platform}
        />
        <Button
          variant="secondary"
          className="rounded-full"
          onClick={() => window.open(url, '_blank', 'noopener')}
        >
          <span className="max-sm:hidden">
            {t('impersonation.report.viewProfile')}
          </span>
          <ExportSquare size={16} color={SocialMirrorPalette.neutralColor} />
        </Button>
      </div>
    </div>
  )
}
